<template>
  <div v-show="syncUI.drawUrl" class="flex_c draw-url">
    <iframe v-if="syncUI.drawUrl" :src="syncUI.drawUrl" frameborder="0" class="draw-iframe"></iframe>
  </div>
</template>
<script>
import {mapState} from 'vuex'
export default {
  computed: {
    ...mapState(['syncUI']),
  },
  watch: {
    'syncUI.drawUrl': {
      handler(o, v) {
        this.$forceUpdate()
      }
    }
  },
  // mounted() {
  //   console.log(this.syncUI, 'drawbox');
  // },
}
</script>

<style scoped>
.draw-url {
  position: fixed;
  z-index: 4000;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  transition: all 0.3s ease;
}

.draw-iframe {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  border: none;
  display: block;
}
</style>

<style>
body.meeting-sidebar-active .draw-url {
  left: 280px !important;
  right: 0 !important;
  width: calc(100% - 280px) !important;
  max-width: calc(100% - 280px) !important;
  transition: all 0.3s ease;
}

body.meeting-sidebar-active.meeting-sidebar-collapsed .draw-url {
  left: 140px !important;
  width: calc(100% - 140px) !important;
  max-width: calc(100% - 140px) !important;
}
</style>
